
import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { queryEmployeeById, addEmployee, editEmployee } from '@/api/employee'
import { listMyStores } from '@/api/store'
import { listRoles } from '@/api/permission'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'addShop',
  components: {
    HeadLable
  }
})
export default class extends Vue {
  private title = '添加人员'
  private actionType = ''
  private customRoles: Array<{ roleValue: number; name: string }> = []
  private ruleForm: any = {
    name: '',
    phone: '',
    email: '',
    sex: '男',
    idNumber: '',
    username: '',
    role: 1,
    storeId: null as number | null
  }

  private storeOptions: Array<{ id: number; storeName: string }> = []

  // private validateRepassword (rule:any, value:any, callback:any) {
  //   if (value === '') {
  //     callback(new Error('请再次输入密码'))
  //   } else if (value !== this.ruleForm.password) {
  //     callback(new Error('两次输入密码不一致!'))
  //   } else {
  //     callback()
  //   }
  // }

  private isCellPhone(val: any) {
    const s = val != null ? String(val).trim() : ''
    return /^1[3-9]\d{9}$/.test(s)
  }

  private checkphone(rule: any, value: any, callback: any) {
    // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
    if (value == '') {
      callback(new Error('请输入手机号'))
    } else if (!this.isCellPhone(value)) {
      //引入methods中封装的检查手机格式的方法
      callback(new Error('请输入正确的手机号!'))
    } else {
      callback()
    }
  }

  get isCourier() {
    return Number(this.ruleForm.role) === 2
  }

  get isManager() {
    return Number(this.ruleForm.role) === 1
  }

  get needStore() {
    return this.isCourier || this.isManager
  }

  get canSetSuperAdmin() {
    return UserModule.isSuperAdmin
  }

  get canSetPlatformAdmin() {
    return UserModule.isPlatformLevel
  }

  private onRoleChange() {
    this.$nextTick(() => {
      const form = this.$refs.ruleForm as any
      if (form && form.clearValidate) {
        form.clearValidate(['email', 'storeId'])
      }
      if ((this.isCourier || this.isManager) && form && form.validateField) {
        form.validateField('email')
        form.validateField('storeId')
      }
      const role = Number(this.ruleForm.role)
      if (role === 0 || role === 3 || role >= 10) {
        this.ruleForm.storeId = null
      }
    })
  }

  private checkEmail(rule: any, value: any, callback: any) {
    if (!this.isCourier && !this.isManager) {
      callback()
      return
    }
    const s = value != null ? String(value).trim() : ''
    if (!s) {
      callback(new Error('请输入邮箱'))
      return
    }
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(s)) {
      callback(new Error('请输入正确的邮箱'))
      return
    }
    callback()
  }

  get rules() {
    return {
      name: [
        {
          required: true,
          // 'message': '请输入员工姓名',
          validator: (rule: any, value: string, callback: Function) => {
            if (!value) {
              callback(new Error('请输入员工姓名'))
            } else {
              // const reg = /^[\u4e00-\u9fa5_a-zA-Z]{1,12}$/
              // if (!reg.test(value)) {
              //   callback(new Error('姓名输入不符，请输入1-12个字符'))
              // } else {
              //   callback()
              // }
              callback()
            }
          },
          trigger: 'blur'
        }
      ],
      username: [
        {
          required: true,
          // message: '请输入账号',
          validator: (rule: any, value: string, callback: Function) => {
            if (!value) {
              callback(new Error('请输入账号'))
              return
            }
            const s = String(value)
            // 允许字母数字及 @？;。 等特殊字符，禁止空格等空白
            if (/\s/.test(s)) {
              callback(new Error('账号不能包含空格'))
              return
            }
            if (s.length < 3 || s.length > 32) {
              callback(new Error('账号输入不符，请输入3-32个字符'))
              return
            }
            callback()
          },
          trigger: 'blur'
        }
      ],
      phone: [{ required: true, validator: this.checkphone, trigger: 'blur' }],
      email: [{ required: true, validator: this.checkEmail, trigger: ['blur', 'change'] }],
      storeId: [
        {
          required: true,
          validator: (rule: any, value: any, callback: Function) => {
            if (!this.needStore) {
              callback()
              return
            }
            if (value == null || value === '') {
              callback(new Error(this.isCourier ? '请选择所属店铺' : '请选择所属门店'))
              return
            }
            callback()
          },
          trigger: ['change', 'blur']
        }
      ]
    }
  }

  created() {
    this.loadStores()
    this.loadCustomRoles()
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    if (this.$route.query.id) {
      this.title = '修改人员信息'
      this.init()
    }
  }

  private async loadCustomRoles() {
    if (!UserModule.isSuperAdmin) {
      this.customRoles = []
      return
    }
    try {
      const res: any = await listRoles()
      if (String(res.data.code) === '1' && Array.isArray(res.data.data)) {
        this.customRoles = res.data.data
          .filter((r: any) => Number(r.systemFlag) !== 1 && Number(r.roleValue) >= 10)
          .map((r: any) => ({ roleValue: Number(r.roleValue), name: r.name }))
      }
    } catch (e) {
      this.customRoles = []
    }
  }

  private async loadStores() {
    try {
      const res: any = await listMyStores()
      if (String(res.data.code) === '1' && Array.isArray(res.data.data)) {
        this.storeOptions = res.data.data
      }
    } catch (e) {
      this.storeOptions = []
    }
  }

  private async init() {
    const id = this.$route.query.id
    queryEmployeeById(id).then((res: any) => {
      // String(res.status) === '200'
      if (res.data.code === 1) {
        this.ruleForm = res.data.data
        this.ruleForm.sex = res.data.data.sex === '0' ? '女' : '男'
        this.ruleForm.role = res.data.data.role != null ? res.data.data.role : 1
        this.ruleForm.storeId = res.data.data.storeId != null ? res.data.data.storeId : null
        // this.ruleForm.password = ''
      } else {
        this.$message.error(res.data.msg)
      }
      // if (res.data.code == 200) {
      //   const { data } = res.data
      //   this.ruleForm = data
      //   this.ruleForm.password = ''
      //   // this.ruleForm.rePassword = '' //JSON.parse(JSON.stringify(data.password));
      // } else {
      //   this.$message.error(res.data.desc)
      // }
    })
  }

  private buildSubmitParams() {
    const role = this.ruleForm.role != null ? Number(this.ruleForm.role) : 1
    const params: any = {
      ...this.ruleForm,
      sex: this.ruleForm.sex === '女' ? '0' : '1',
      role,
      storeId: role === 0 || role === 3 || role >= 10 ? null : (this.ruleForm.storeId || null)
    }
    if (role === 1 || role === 2) {
      params.email = String(this.ruleForm.email || '').trim()
    }
    // 前端不再采集身份证号：新增给空串；编辑不覆盖库中原值
    if (this.actionType === 'add') {
      params.idNumber = ''
    } else {
      delete params.idNumber
    }
    return params
  }

  private submitForm(formName: any, st: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (!valid) return
      const role = Number(this.ruleForm.role)
      if ((role === 1 || role === 2) && !this.ruleForm.storeId) {
        this.$message.warning(role === 2 ? '派送员必须选择所属店铺' : '商家管理员必须选择所属门店')
        return
      }
      if (this.isCourier || this.isManager) {
        const email = String(this.ruleForm.email || '').trim()
        if (!email) {
          this.$message.warning(this.isManager ? '商家管理员邮箱为必填' : '派送员邮箱为必填')
          return
        }
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
          this.$message.warning('请输入正确的邮箱')
          return
        }
      }
      if (this.actionType === 'add') {
        const params = this.buildSubmitParams()
        addEmployee(params)
          .then((res: any) => {
            if (res.data.code === 1) {
              this.$message.success('人员添加成功！')
              if (!st) {
                this.$router.push({ path: '/employee' })
              } else {
                this.ruleForm = {
                  username: '',
                  name: '',
                  phone: '',
                  email: '',
                  sex: '男',
                  idNumber: '',
                  role: 1,
                  storeId: null
                }
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
            // this.$message.error('请求出错了：' + err.message)
          })
      } else {
        const params = this.buildSubmitParams()
        editEmployee(params)
          .then((res: any) => {
            if (res.data.code === 1) {
              this.$message.success('人员信息修改成功！')
              this.$router.push({ path: '/employee' })
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
            // this.$message.error('请求出错了：' + err.message)
          })
      }
    })
  }
}
